import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { loading: true, data: false, error: false };

export function singleValidatorReducer(state = initialState, action) {
   
    switch (action.type) {
        case AnalyzeConstants.SINGLE_VALIDATOR_FALSE:
        return {
            loading: false,
            data: false,
            error: false
        };
        case AnalyzeConstants.SINGLE_VALIDATOR:
            return {
                loading: false,
                data: true,
                error: false
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/singleValidator.reducer.js